<template>
	<v-dropdown
		v-model:open="is_open"
		variant="bubble"
		color="orange"
		:icon="icon"
		:label="label"
		:full_label="full_label"
	>
		<div class="filter-group range-dropdown">
			<div class="filter-group-header">
				<v-icon :slug="icon" />

				<span class="label">{{ heading }}</span>
			</div>

			<p class="range-description" v-html="description_text" />

			<input v-model.number="draft" type="range" :min="min" :max="max" :step="step" class="range-input" />

			<button type="button" class="btn btn-solid small" @click="apply">Apply</button>
		</div>
	</v-dropdown>
</template>

<style lang="scss" scoped>
@use 'sass:math';

@use '/sass/variables' as *;
@use '/sass/toolkit' as *;

@include filter-group;

.range-dropdown {
	min-width: 14em;
	padding: 1em;

	.range-description {
		margin-bottom: 0;
		font-size: 0.875rem;
	}

	.range-input {
		width: 100%;
		margin-bottom: math.div($spacer, 2);
		accent-color: $orange;
	}

	.btn-solid {
		width: 100%;
	}
}
</style>

<script setup>
import { computed, ref, watch } from 'vue';

import VDropdown from './_v-dropdown.vue';
import VIcon from './_v-icon.vue';

const props = defineProps({
	icon: {
		type: String,
		required: true,
	},
	label: {
		type: String,
		required: true,
	},
	full_label: {
		type: String,
		required: false,
		default: null,
	},
	heading: {
		type: String,
		required: true,
	},
	description: {
		type: String,
		required: true,
	},
	min: {
		type: Number,
		required: true,
	},
	max: {
		type: Number,
		required: true,
	},
	step: {
		type: Number,
		required: false,
		default: 1,
	},
});

const emit = defineEmits([`change`]);

const model = defineModel({
	type: Number,
	required: true,
});

const is_open = ref(false);

const draft = ref(model.value);

watch(is_open, () => {
	draft.value = model.value;
});

const description_text = computed(() => props.description.replace(`{value}`, `<strong>${draft.value}</strong>`));

function apply() {
	model.value = draft.value;

	emit(`change`);

	is_open.value = false;
}
</script>
